import React, { Fragment } from "react";
import { graphql } from "gatsby";
import Block from "../../Block";
import Blocks from "templates/Blog/Gutenberg/Blocks";

class CoreColumn extends Block {
  render() {
    const { block } = this.props;

    return (
      <Fragment>
        <Blocks blocks={block.innerBlocks} />
      </Fragment>
    );
  }
}

class CoreColumnFactory {
  constructor(blockBuildingFactory) {
    this.blockBuildingFactory = blockBuildingFactory;
  }

  get type() {
    return "core/column";
  }

  create(props) {
    return <CoreColumn factory={this.blockBuildingFactory} {...props} />;
  }
}

export default CoreColumnFactory;
